export interface ShipperResponse {
  trackingNumber: string;
  errorMessage: string;
  label: string;
  contentType: string;
}
